export default "__VITE_ASSET__e8a0936c__"